import styles from "./styles.module.scss";
import img1 from "./img/img1.png";
import img2 from "./img/img2.png";
import img3 from "./img/img3.png";
import img4 from "./img/img4.png";

import { IconCard } from "../../../../shared";
import { IconCardWalky } from "src/routes/onboarding/shared/components/iconCardWalky";
import { WALKY_KEYS } from "src/routes/onboarding/shared/constants/walkyKeys";

const data = [
  {
    value: "BEGINNER", // ?
    points: "1",
    displayValue: "Beginner",
    paragraph: "Doing some chores and spending most of my time seated.",
    emoji: img1,
    small: true,
  },
  {
    value: "INTERMEDIATE",
    points: "2",
    displayValue: "Intermediate",
    paragraph:
      "I walk or engage in light physical activities more than 3 days per week.",
    emoji: img2,
    small: true,
  },
  {
    value: "MODERATELY_ACTIVE",
    points: "3",
    displayValue: "Moderately active",
    paragraph: "My job is physically intensive and often quite strenuous.",
    emoji: img3,
    small: true,
  },
  {
    value: "HIGHLY_ACTIVE",
    points: "4",
    displayValue: "High active",
    paragraph:
      "Either doing physical labor or walking consistently throughout the day.",
    emoji: img4,
    small: true,
  },
];
export const ActivityLevel = ({ onNextStep, onTrackEvent }) => {
  const handleNextStep = (v) => {
    localStorage.setItem(WALKY_KEYS.activityLevel, v.points);
    onNextStep(v.value);
    onTrackEvent?.(v.value);
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2>What is your activity level?</h2>
        <div className={styles.cards}>
          {data.map((value) => (
            <IconCardWalky
              onClick={() => handleNextStep(value)}
              img={value.emoji}
              paragraph={value.paragraph}
              title={value.displayValue}
              key={value.points}
              small={value.small}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
